exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".dynamic-field{display:flex;align-items:center;width:100%}.empty-highlight .v-input__slot{background-color:#f9fbe7 !important}", ""]);

